import React, { forwardRef } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/**
 * Salesperson Project Approved: "Accept" (POST /project-assigned/direct-accept) above "Forward"
 * (POST /project-assigned). Parent builds identical req.body for both; parent handles click-outside.
 */
const ActionForwardApproved = forwardRef(function ActionForwardApproved(
  {
    menuKey,
    openMenuKey,
    setOpenMenuKey,
    disabled = false,
    isForwarded,
    onAccept,
    onForward,
    onCancelForwarded,
    childrenAfterForward,
    newManagerMode = false,
    rootClassName = "w-[80%]",
  },
  ref
) {
  const isOpen = openMenuKey === menuKey;

  const toggle = () => {
    if (disabled) return;
    setOpenMenuKey(isOpen ? null : menuKey);
  };

  const close = () => setOpenMenuKey(null);

  const buttonLabel = newManagerMode
    ? "Select Option"
    : isForwarded
      ? "Forwarded"
      : "Select Option";

  return (
    <div
      ref={ref}
      className={`relative flex p-0 rounded-xl align-middle items-center ${rootClassName}`}
    >
      <button
        type="button"
        disabled={disabled}
        onClick={toggle}
        className={`relative border w-full text-xs border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${disabled ? "bg-gray-100 text-gray-400 cursor-not-allowed" : ""}`}
      >
        {buttonLabel}
        <ExpandMoreIcon
          className={`absolute top-1 right-0 bg-white ${disabled ? "cursor-not-allowed text-gray-400" : "cursor-pointer group-hover:bg-gray-100"}`}
          onClick={(e) => {
            e.stopPropagation();
            if (disabled) return;
            toggle();
          }}
        />
      </button>
      {isOpen && !disabled && (
        <div
          style={{ zIndex: 9999 }}
          className="text-start bg-white absolute top-full left-0 w-full p-1 cursor-pointer overflow-y-auto text-xs border border-gray-300 shadow-lg flex flex-col gap-1"
        >
          {newManagerMode && onAccept && onForward && (
            <>
              <div
                className="p-1 hover:bg-gray-200 cursor-pointer"
                onClick={() => {
                  close();
                  onAccept();
                }}
              >
                Accept
              </div>
              <div
                className="p-1 hover:bg-gray-200 cursor-pointer"
                onClick={() => {
                  close();
                  onForward();
                }}
              >
                Forward
              </div>
            </>
          )}

          {!newManagerMode && !isForwarded && onAccept && onForward && (
            <>
              <div
                className="p-1 bg-white hover:bg-gray-200 cursor-pointer"
                onClick={() => {
                  close();
                  onAccept();
                }}
              >
                Accept
              </div>
              <div
                className="p-1 bg-white hover:bg-gray-200 cursor-pointer"
                onClick={() => {
                  close();
                  onForward();
                }}
              >
                Forward
              </div>
            </>
          )}

          {!newManagerMode && childrenAfterForward}

          {!newManagerMode && isForwarded && onCancelForwarded && (
            <div
              onClick={() => {
                close();
                onCancelForwarded();
              }}
              className="p-1 bg-white hover:bg-gray-200 cursor-pointer"
            >
              Cancel
            </div>
          )}
        </div>
      )}
    </div>
  );
});

export default ActionForwardApproved;
